import React from 'react';
import { Link } from 'react-router-dom';
import { TechLayout } from '../components/TechLayout';
import { TechHero } from '../components/TechHero';
import { TechFeatureSection } from '../components/TechFeatureSection';
import { TechCard } from '../components/TechCard';
import { PackageIcon, UsersIcon, SparklesIcon, TrendingUpIcon, MessageSquareIcon, CalendarIcon, BarChartIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
export function Home() {
  const features = [{
    icon: <SparklesIcon className="h-6 w-6" data-id="element-2343" />,
    title: 'AI-Powered Matching',
    description: 'Our intelligent algorithms connect brands with the perfect event organizers based on your specific goals and audience.'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-2344" />,
    title: 'Increased Exposure',
    description: 'Gain valuable exposure to your target audience through carefully matched events and partnerships.'
  }, {
    icon: <MessageSquareIcon className="h-6 w-6" data-id="element-2345" />,
    title: 'Streamlined Communication',
    description: 'Direct messaging and collaboration tools make it easy to connect and finalize partnerships.'
  }, {
    icon: <CalendarIcon className="h-6 w-6" data-id="element-2346" />,
    title: 'Event Management',
    description: 'Organize and track all your sponsorship activities in one centralized dashboard.'
  }, {
    icon: <BarChartIcon className="h-6 w-6" data-id="element-2347" />,
    title: 'Performance Analytics',
    description: 'Measure the impact of your sponsorships with detailed reporting and insights.'
  }, {
    icon: <ZapIcon className="h-6 w-6" data-id="element-2348" />,
    title: 'Quick Setup',
    description: 'Get started in minutes with our intuitive onboarding process.'
  }];
  return <TechLayout data-id="element-2349">
      <TechHero title="Connect Brands with Event Organizers Effortlessly" subtitle="SponsrAI is the perfect platform for brands to find sampling opportunities and for event organizers to secure valuable sponsorships." ctaText="Get Started" ctaLink="/register" secondaryCtaText="Learn More" secondaryCtaLink="#features" data-id="element-2350" />

      {/* Features Section */}
      <div id="features" data-id="element-2351">
        <TechFeatureSection title="Platform Benefits" subtitle="Discover how SponsrAI makes brand-organizer connections seamless and effective" features={features} data-id="element-2352" />
      </div>

      {/* How It Works */}
      <div className="bg-gray-50 py-16" data-id="element-2353">
        <div className="container mx-auto px-4" data-id="element-2354">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-2355">
            How It Works
          </h2>
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-2356">
            <TechCard title="For Brands" icon={<PackageIcon className="h-6 w-6" data-id="element-2358" />} description="Connect with the right events to showcase your products and reach your target audience." footer={<div data-id="element-2359">
                  <ol className="space-y-2 mb-4" data-id="element-2360">
                    <li className="flex items-start" data-id="element-2361">
                      <span className="bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold mr-2 mt-0.5" data-id="element-2362">
                        1
                      </span>
                      <span className="text-gray-700" data-id="element-2363">
                        List your products and sponsorship offerings
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2364">
                      <span className="bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold mr-2 mt-0.5" data-id="element-2365">
                        2
                      </span>
                      <span className="text-gray-700" data-id="element-2366">
                        Specify your target audience and goals
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2367">
                      <span className="bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold mr-2 mt-0.5" data-id="element-2368">
                        3
                      </span>
                      <span className="text-gray-700" data-id="element-2369">
                        Get matched with relevant events
                      </span>
                    </li>
                  </ol>
                  <Link to="/onboarding/brand" className="text-blue-600 font-medium hover:text-blue-800 flex items-center" data-id="element-2370">
                    Get Started as a Brand
                    <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-2371" />
                  </Link>
                </div>} data-id="element-2357" />
            <TechCard title="For Organizers" icon={<UsersIcon className="h-6 w-6" data-id="element-2373" />} description="Find the perfect brand sponsors for your events and provide value to your attendees." footer={<div data-id="element-2374">
                  <ol className="space-y-2 mb-4" data-id="element-2375">
                    <li className="flex items-start" data-id="element-2376">
                      <span className="bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold mr-2 mt-0.5" data-id="element-2377">
                        1
                      </span>
                      <span className="text-gray-700" data-id="element-2378">
                        Share details about your event and audience
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2379">
                      <span className="bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold mr-2 mt-0.5" data-id="element-2380">
                        2
                      </span>
                      <span className="text-gray-700" data-id="element-2381">
                        Describe sponsorship opportunities
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-2382">
                      <span className="bg-blue-100 text-blue-800 rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold mr-2 mt-0.5" data-id="element-2383">
                        3
                      </span>
                      <span className="text-gray-700" data-id="element-2384">
                        Connect with relevant brands
                      </span>
                    </li>
                  </ol>
                  <Link to="/onboarding/organizer" className="text-blue-600 font-medium hover:text-blue-800 flex items-center" data-id="element-2385">
                    Get Started as an Organizer
                    <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-2386" />
                  </Link>
                </div>} data-id="element-2372" />
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-blue-600 py-16" data-id="element-2387">
        <div className="container mx-auto px-4 text-center" data-id="element-2388">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-2389">
            Ready to transform your sponsorship strategy?
          </h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-2390">
            Join SponsrAI today and start connecting with the perfect partners
            for your brand or event.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-2391">
            <Link to="/register" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 rounded-md font-medium transition-colors" data-id="element-2392">
              Create Account
            </Link>
            <Link to="/login" className="bg-blue-700 text-white hover:bg-blue-800 px-8 py-3 rounded-md font-medium transition-colors border border-blue-500" data-id="element-2393">
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </TechLayout>;
}